export default __webpack_public_path__ + "static/media/visa.a72aec94.svg";